// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KMd7","col":"styles_col__1y0A9"};